import * as React from 'react';
import FieldHandler from '../../../models/interfaces/FieldHandler';
import SelectField from '../../common/form-controls/SelectField';
import { OnPremPortOpeningRequestsTypes } from '../../../models/enums/POR/OnPremPortOpeningRequestsTypes';

interface OnPremPORTypeInputProps {
	type: FieldHandler<string>;
}

interface OnPremPORTypeInputState { }

export class OnPremPORTypeInput extends React.Component<OnPremPORTypeInputProps, OnPremPORTypeInputState> {

	typeOptions = () => {
		return [
			{ value: OnPremPortOpeningRequestsTypes.InternetDMZ.name, text: OnPremPortOpeningRequestsTypes.InternetDMZ.displayName },
			{ value: OnPremPortOpeningRequestsTypes.InternalCertConnection.name, text: OnPremPortOpeningRequestsTypes.InternalCertConnection.displayName },
		];
	};
	
	render() {
		return (
			<SelectField
				label="Type"
				className="full-width"
				options={this.typeOptions()}
				{...this.props.type}
			/>
		);
	}
}
